// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__pdMcr","caret":"Breadcrumbs_caret__1L4wc"};